// Components
import { BaseTable, FooterMenu, HeaderMenu, Loading, PermissionLink, Select, TableHeader } from "components"

// Icons
import { IoSendSharp } from "react-icons/io5"

// Third-Party Libraries
import moment from "moment"

// Utils
import { convertNumber } from "utils"
import { default_option } from "pages/Purchase/utils"
import { statusList, useList } from "./utils"
import { PERMISION } from "security"

export default function ReturnRecord(): JSX.Element {
  // Hooks
  // const employee = useEmployee()
  const { data, isLoading, returnStatus, changeStatus } = useList()
  return (
    <div className="container my-5 flex flex-col gap-3">
      <HeaderMenu title="DATA ENTRY | RETURN RECORD" />

      <div className="w-[300px]">
        <Select
          label="STATUS RETURN"
          placeholder="Select Status"
          options={statusList}
          value={statusList.find(item => item.value === returnStatus) ?? null}
          onChange={res => {
            if (res) {
              changeStatus(res.value)
            }
          }}
        />
      </div>
      <div className="overflow-x-auto max-h-[calc(100vh-500px)]">
        <BaseTable>
          <TableHeader>
            <tr>
              <th>NO</th>
              <th colSpan={2}>RETURN ITEM ID#</th>
              <th>DATE</th>
              <th>LINK INVOICE ID#</th>
              <th>CUSTOMER</th>
              <th>QTY RETURN</th>
              <th>TOTAL</th>
              <th>LOCATION</th>
              <th>MEMO</th>
              <th>STATUS APPROVE</th>
              <th>STATUS RETURN</th>
              <th>APPROVE BY</th>
            </tr>
          </TableHeader>

          <tbody>
            {isLoading || !data.length ? (
              <tr>
                <td colSpan={13}>
                  <Loading
                    errorText="No data available"
                    loading={isLoading}
                  />
                </td>
              </tr>
            ) : data.map((item, key) => (
              <tr key={key}>
                <td className="text-center">{key + 1}</td>

                <td>
                  <PermissionLink permission={PERMISION.SALES.TRANSACTION.CREATE_RETURNED_RECORD.UPDATE} to={`/sales/transaction/return-record/${item.return_id}`}>
                    <IoSendSharp />
                  </PermissionLink>
                </td>

                <td className="text-center">{item.trx_code}</td>
                <td className="text-center">{moment(item.transaction_date).format("DD/MM/YYYY")}</td>
                <td className="text-center">{item.trx_invoice_code}</td>
                <td>{item.customer_name}</td>
                <td className="text-right">{convertNumber(item.qty_return).intoCurrency}</td>
                <td className="text-right">{convertNumber(item.total).intoCurrency}</td>
                <td>{item.location_name}</td>
                <td>{item.memo}</td>
                <td>{default_option.find(i => i.value === item.approve_status.toString())?.label ?? "-"}</td>
                <td>{statusList.find(i => i.value === item.return_status.toString())?.label ?? "-"}</td>

                <td>
                  {item.approve_by_name}
                </td>
              </tr>
            ))}
          </tbody>
        </BaseTable>
        
      </div>

      <FooterMenu />
    </div>
  )
}